(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(255);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
;// CONCATENATED MODULE: ./src/templates/home.jsx

function HomeTemplate(param) {
    var page = param.page, renderSections = param.renderSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: renderSections()
    });
}
HomeTemplate.displayName = "HomeTemplate";

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
;// CONCATENATED MODULE: ./src/pages/index.jsx
/* eslint-disable import/extensions, import/no-unresolved */ 





var __N_SSG = true;
function Index(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var homePage = props === null || props === void 0 ? void 0 : props.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: homePage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTemplate, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                renderSections: renderSections
            }))
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(5183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);